// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "hr.navbar-break[data-v-571c57ca]{height:1px;margin:0 0 2rem;background-color:hsla(0,0%,100%,.1)}.main-logo-container[data-v-571c57ca]{justify-content:start;padding-left:1.5rem;width:60%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
